import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../../hooks/context/AuthContext";

interface IProtectedRouteProps {
    includeNav?: boolean;
    children?: React.ReactNode;
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ children }) => {
    const { isSignedIn, isAuthResolved } = useAuthContext();

    if (!isAuthResolved) return null;

    if (!isSignedIn) return <Navigate to="/login" replace />;

    return <>{children ?? <Outlet />}</>;
};

export default ProtectedRoute;
